// extracted by mini-css-extract-plugin
module.exports = {"like":"_2VYar","liked":"_17gDi","not-clickable":"_2fLoF","notClickable":"_2fLoF","like-button":"_3isP5","likeButton":"_3isP5","likes":"fNXJN"};